import { createFileRoute } from "@tanstack/react-router";
import { AgentCliOverview } from "@/components/agent-cli-pages";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/agent";
export const Route = createFileRoute("/agent/")({
	component: AgentCliOverview,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "CLI and Skills for Social Media Agents",
			description:
				"Install the AgentReacher CLI and agent skill to plan, review, schedule, publish, and monitor social campaigns across nine platforms.",
		}),
});
